export const formatDataTestId = (input: string): string => {
  return input
    .trim()
    .toLowerCase()
    .replace(/[\s_,\-]+/g, "-") // Replace spaces, underscores, and hyphens with a single hyphen
    .replace(/[!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~`]/g, "") // Remove special characters
    .replace(/[^\w-]+/g, "") // Remove any remaining non-word characters except hyphens
    .replace(/^-+|-+$/g, "") // Remove leading and trailing hyphens
    .replace(/-{2,}/g, "-"); // Replace multiple consecutive hyphens with a single hyphen
};

export const createDataTestId = (
  dataTestIdInputs: string | string[],
): string => {
  return Array.isArray(dataTestIdInputs)
    ? formatDataTestId(dataTestIdInputs.join(" "))
    : formatDataTestId(dataTestIdInputs);
};
